<div [formGroup]="formGroup">
    <z-form-field>
        <label z-form-label>
            {{ stateLabel }}
            @if (isRequired) {
                <span class="state-district-fields__required">*</span>
            }
        </label>
        <z-form-control>
            <input
                type="text"
                z-input
                [formControlName]="stateControlName"
                (input)="onStateInput($event)"
                (focus)="stateAuto.open()"
                (blur)="stateAuto.delayedClose(); formGroup.get(stateControlName)?.markAsTouched()"
            />
        </z-form-control>
        <tw-autocomplete #stateAuto (optionSelected)="onStateChange()">
            @for (state of filteredStateOptions; track state) {
                <tw-autocomplete-option [value]="state">{{ state }}</tw-autocomplete-option>
            }
            @if (!filteredStateOptions.length) {
                <tw-autocomplete-option [disabled]="true">
                    <div class="no-data-found">No matching states found</div>
                </tw-autocomplete-option>
            }
        </tw-autocomplete>
        @if (
            formGroup.get(stateControlName)?.hasError('required') &&
            formGroup.get(stateControlName)?.touched
        ) {
            <z-form-message zType="error">{{ stateLabel }} is required</z-form-message>
        }
    </z-form-field>

    <z-form-field>
        <label z-form-label>
            {{ districtLabel }}
            @if (isRequired) {
                <span class="state-district-fields__required">*</span>
            }
        </label>
        <z-form-control>
            <div class="relative w-full">
                <input
                    type="text"
                    z-input
                    class="pr-10"
                    [formControlName]="districtControlName"
                    (focus)="districtAuto.open()"
                    (blur)="
                        districtAuto.delayedClose();
                        formGroup.get(districtControlName)?.markAsTouched()
                    "
                    [disabled]="!districtOptions.length || isDistrictLoading"
                />
                @if (isDistrictLoading) {
                    <span
                        class="state-district-fields__spinner absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                    >
                        <z-loader zSize="sm" />
                    </span>
                }
            </div>
        </z-form-control>
        <tw-autocomplete #districtAuto>
            @for (district of districtOptions; track district) {
                <tw-autocomplete-option [value]="district">{{ district }}</tw-autocomplete-option>
            }
            @if (
                !isDistrictLoading &&
                !districtOptions.length &&
                formGroup.get(stateControlName)?.value
            ) {
                <tw-autocomplete-option [disabled]="true">
                    <div class="no-data-found">No districts available for selected state</div>
                </tw-autocomplete-option>
            }
        </tw-autocomplete>
        @if (
            formGroup.get(districtControlName)?.hasError('required') &&
            formGroup.get(districtControlName)?.touched
        ) {
            <z-form-message zType="error">{{ districtLabel }} is required</z-form-message>
        }
        @if (
            !districtOptions.length && formGroup.get(stateControlName)?.value && !isDistrictLoading
        ) {
            <z-form-message>No districts found for selected state</z-form-message>
        }
    </z-form-field>
</div>
